import { Box, HStack, Link, Text, VStack } from '@chakra-ui/react';
import { IconGraduateCap } from 'central-icons/IconGraduateCap';
import { isEmpty } from 'lodash';

interface EducationHistoryItem {
  title?: string;
  university_name?: string;
  start_date?: string;
  end_date?: string;
}

interface EducationHistorySectionProps {
  educationHistory: EducationHistoryItem[];
  isExpanded: boolean;
  onToggleExpanded: () => void;
}

const formatDateToYear = (dateString: string) => {
  if (isEmpty(dateString)) return '';
  const [year] = dateString.split('-');
  return year;
};

export const EducationHistorySection = ({
  educationHistory,
  isExpanded,
  onToggleExpanded,
}: EducationHistorySectionProps) => {
  if (!educationHistory.length) return null;

  const sortedEducationHistory = educationHistory.sort((a, b) => {
    const aDate = String(a.start_date ?? '');
    const bDate = String(b.start_date ?? '');
    if (aDate > bDate) return -1;
    if (aDate < bDate) return 1;
    return 0;
  });

  const displayEducationHistory = isExpanded
    ? sortedEducationHistory
    : sortedEducationHistory.slice(0, 1);

  return (
    <HStack spacing={2} fontSize="sm" color="text.primary" align="start">
      <Box flexShrink={0} mt="2px">
        <IconGraduateCap size={16} />
      </Box>
      <VStack align="start" spacing={0} flex={1}>
        {displayEducationHistory.map((edu, idx) => {
          const isLastDisplayedEducation =
            idx === displayEducationHistory.length - 1;
          return (
            <Text key={idx}>
              <Text as="span" fontWeight="medium">
                {String(edu.title ?? '')}
              </Text>
              {/** biome-ignore lint/style/useConsistentCurlyBraces: migrated from develop */}
              {' @ '}
              <Text as="span">{String(edu.university_name ?? '')}</Text> (
              {formatDateToYear(String(edu.start_date ?? ''))}-
              {edu.end_date
                ? formatDateToYear(String(edu.end_date))
                : 'present'}
              )
              {isLastDisplayedEducation &&
                sortedEducationHistory.length > 1 && (
                  <>
                    {' '}
                    <Link
                      color="lightBlue.600"
                      fontSize="xs"
                      fontWeight="600"
                      textDecoration="underline"
                      ml={1}
                      onClick={(e) => {
                        e.stopPropagation();
                        onToggleExpanded();
                      }}
                      cursor="pointer"
                    >
                      {isExpanded ? 'Show Less' : 'More'}
                    </Link>
                  </>
                )}
            </Text>
          );
        })}
      </VStack>
    </HStack>
  );
};
